<template>
  <div>
    <span v-if="customFields.length > 0">{{legendTitle}}</span>
    <ul v-if="customFields.length > 0">
      <li v-for="(item, index) in customFields" v-bind:key="index">
        {{$t('views.excmnotificationmessage.legend.singleCustomField', {fieldName: '%' + item.fieldName + '%', fieldLabel: item.fieldLabel})}}
      </li>
    </ul>
  </div>
</template>

<script>
import ApiService from '@/utils/ApiService'

export default {
  name: 'customFieldLegend',
  props: {
    notificationMessage: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    firingThroughObject: {
      handler (val) {
        this.fetchData()
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      firingThroughCaseOptions: [1, 2, 8],
      firingThroughTaskOptions: [3, 4, 5, 6, 7, 9, 10],
      currentTask: null,
      currentCase: null
    }
  },
  computed: {
    customFields () {
      if (this.firingThrough === 'case' && this.currentCase) {
        return this.currentCase.customFields
      } else if (this.firingThrough === 'task' && this.currentTask) {
        return this.currentTask.customFields
      } else {
        return []
      }
    },
    firingThrough () {
      if (this.firingThroughCaseOptions.includes(this.notificationMessage.firingThrough)) {
        return 'case'
      } else if (this.firingThroughTaskOptions.includes(this.notificationMessage.firingThrough)) {
        return 'task'
      } else {
        return null
      }
    },
    firingThroughObject () {
      return {
        firingThrough: this.firingThrough,
        caseType: this.notificationMessage.caseType,
        taskType: this.notificationMessage.taskType
      }
    },
    legendTitle () {
      let title = this.$t('views.excmnotificationmessage.legend.customFieldLegend')
      if (this.firingThrough === 'case') {
        title += ' ' + this.$t('views.excmnotificationmessage.legend.forCase')
        if (this.currentCase) {
          title += ' "' + this.currentCase.title + '"'
        }
      } else if (this.firingThrough === 'task') {
        title += ' ' + this.$t('views.excmnotificationmessage.legend.forTask')
        if (this.currentTask) {
          title += ' "' + this.currentTask.title + '"'
        }
      }
      return title
    }
  },
  methods: {
    async fetchData () {
      if (this.firingThrough === 'case') {
        this.currentTask = null
        this.currentCase = await new ApiService(this.notificationMessage.caseType).getResults()
      } else if (this.firingThrough === 'task') {
        this.currentCase = null
        this.currentTask = await new ApiService(this.notificationMessage.taskType).getResults()
      }
    }
  }
}
</script>
